<template>
  <nav v-if="page && page.path !== '/'" class="public-breadcrumb" :aria-label="$i18n.locale === 'zh' ? '页面位置' : 'Breadcrumb'">
    <router-link :to="$siteLink('/')">{{ $i18n.locale === 'zh' ? '首页' : 'Home' }}</router-link>
    <span aria-hidden="true">/</span>
    <span aria-current="page">{{ page[$i18n.locale].label }}</span>
  </nav>
</template>

<script>
import { publicPages } from '@/public-pages'
export default {
  computed: {
    page () { return publicPages.find(page => page.path === this.$route.meta.publicPage) }
  }
}
</script>

<style scoped>
.public-breadcrumb { display: flex; flex-wrap: wrap; gap: 8px 12px; max-width: 1140px; margin: 0 auto; padding: 24px clamp(24px, 6vw, 64px) 0; color: #435164; font-size: 14px; line-height: 1.6; }
.public-breadcrumb a { color: #163257; text-decoration: underline; text-underline-offset: 3px; }
</style>
